import { client } from "@lib/api"
import * as Sentry from "@sentry/react"

type InitiatedPaymentLinkResponse = {
    uuid: string
    link: string
    merchant_uuid: string
    activity_uuid: string
    expected_amount: number
    type: string
    status: string
    expiry_date: Date
    created_at: Date
}

const useManagePaymentLink = () => {
    const initiatePaymentLink = async (expected_amount: number) => {
        try {
            const response: InitiatedPaymentLinkResponse = await client.doPost('/wallet/payment-link', {
                expected_amount: expected_amount
            })
            return response
        } catch (error) {
            Sentry.captureException(error)
            throw error
        }
    }

    const voidPaymentLink = async (payment_link_uuid: string) => {
        try {
            const response = await client.doPost('/wallet/payment-link/void', {
                uuid: payment_link_uuid
            })
            return response
        } catch (error) {
            Sentry.captureException(error)
            throw error
        }
    }

    return {
        initiatePaymentLink,
        voidPaymentLink
    }
}

export default useManagePaymentLink